import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "attribution-lozenge" }
const _hoisted_2 = ["src"]

import SeratoLogo from '@/assets/SeratoLogo.svg'
import { GallerySource } from '@/store/gallery/types'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AttributionLozenge',
  props: {
    attribution: null
  },
  setup(__props: any) {

const props = __props as {
  attribution: GallerySource
};

const pexelAttributionSrc = 'https://static.serato.com/visualizer/images/PexelsLogo.png'



const src = computed(() => props.attribution !== 'serato' ? pexelAttributionSrc : '')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(src))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "attribution-lozenge__logo",
          src: _unref(src)
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createBlock(_unref(SeratoLogo), {
          key: 1,
          class: "attribution-lozenge__logo attribution-lozenge__logo--serato"
        }))
  ]))
}
}

})